import * as React from 'react'

function SvgIconVersionFork(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="version-fork" aria-labelledby="t-version-fork d-version-fork">
        <title id="t-version-fork">{'Fork version'}</title>
        <desc id="d-version-fork">{'Two lines diverge from a point'}</desc>
        <path d="M31.7 7.3l-7-7c-.4-.4-1-.4-1.4 0l-7 7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L23 3.4V20c0 3.3-2.7 6-6 6h-6.2c-.3-.8-1-1.5-1.8-1.8V7.8c1.2-.4 2-1.5 2-2.8 0-1.345-.819-2.427-2-2.826V0H7v2.174C5.819 2.573 5 3.655 5 5c0 1.3.8 2.4 2 2.8v16.4c-1.2.4-2 1.5-2 2.8 0 1.346.819 2.428 2 2.826V32h2v-2.173A2.892 2.892 0 0010.8 28H17c4.4 0 8-3.6 8-8V3.4l5.3 5.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zM6 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 24c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      </g>
    </svg>
  )
}

export default SvgIconVersionFork
